import { Component, OnInit, Input } from '@angular/core';
import { NJDocData, NJReadDocDefTemplateLookup, NJDocDefTemplate } from '../DOData';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

@Component({
    selector: 'cylib-grid-ncheckbox-comments',
    templateUrl: './grid-ncheckbox-comments.component.html',
    styleUrls: ['./grid-ncheckbox-comments.component.css']
})
export class GridNCheckboxCommentsComponent implements OnInit {

    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() public loaderKey: string;

    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>;
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>;
    @Input() customParameters: any;
    @Input() allowDoubleClick: boolean;

    @Input() isValid: boolean = true;
    @Input() isEnabled: boolean = true;
    ignorLabel: boolean = false;
    public lstGridTemp: Array<NJDocDefTemplate>;
    public txtTemp: NJDocDefTemplate;
    public lstGridData: Array<NJDocData> = new Array<NJDocData>();
    public txtData: NJDocData;
    public isTextValid = true;
    constructor() { }
    ngOnInit() { 
        // Setup input to grid lstGridTemp (templates for grid of checkboxes), tmpGridData grid data.
        this.lstGridTemp = this.lstChildDocDefTemplate.filter(function (item) {
            return item.tType == 'CheckboxChild';
        });
        let _this = this;
        let tmpGridData: Array<NJDocData> = (this.lstDocData.filter(function (item) {
            let ret: boolean = false;
            for (var i = 0; i < _this.lstGridTemp.length; i++) {
                if (item.docDefTemplateID == _this.lstGridTemp[i].docDefTemplateID) {
                    ret = true;
                    break;
                }
            }
            return ret;
        }));
        this.lstGridData = DocDefPrimLibService.createNew(tmpGridData);
        // Setup input to grid txtTemp (template for comments/text), tmpTxtData text data.
        let lstTemplate: Array<NJDocDefTemplate> = this.lstChildDocDefTemplate.filter(function (item) {
            return item.tType == 'Comments';
        });
        if (lstTemplate.length > 0) {
            this.txtTemp = lstTemplate[0];
            let _this = this;
            this.txtData = (this.lstDocData.filter(function (item) {
                return item.docDefTemplateID == _this.txtTemp.docDefTemplateID
            }))[0];
            this.isTextValid = this.txtTemp.isValid && this.isValid;
        }
    }
    classFromParams() {
        let ret: string = "";
        
        if (this.customParameters['checkboxCommentClass'] != null) {
            ret = ret + " " + this.customParameters['checkboxCommentClass'];
        }
        return ret;
    }
    onclickBut(ev: any) {
    }
    onTabEvent(ev: any) {
    }
}
